import React, { useState } from 'react';
import { Grid, TextField, InputAdornment, Typography } from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';

export default function UserProfileForm({ initialData, onSubmit }) {
  const [formData, setFormData] = useState({
    firstName: initialData?.firstName || '',
    lastName: initialData?.lastName || '',
    phoneNumber: initialData?.phoneNumber || '',
    employeeTitle: initialData?.employeeTitle || '',
    employeeRate: initialData?.employeeRate || '',
    birthday: initialData?.birthday ? dayjs(initialData.birthday) : null,
    hireDate: initialData?.hireDate ? dayjs(initialData.hireDate) : null,
  });

  const [errors, setErrors] = useState({});
  const { t } = useTranslation();

  const validateForm = () => {
    const newErrors = {};    
    if (!formData.firstName?.trim()) {
      newErrors.firstName = t(StringKeys.FIRST_NAME_IS_REQUIRED);
    }
    if (!formData.lastName?.trim()) {
      newErrors.lastName = t(StringKeys.LAST_NAME_IS_REQUIRED);
    }
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = t(StringKeys.PHONE_NUMBER_IS_REQUIRED);
    }
    // if (!formData.employeeTitle?.trim()) {
    //   newErrors.employeeTitle = t(StringKeys.TITLE_IS_REQUIRED);
    // }
    // if (!formData.employeeRate) {
    //   newErrors.employeeRate = t(StringKeys.EMPLOYEE_RATE_IS_REQUIRED);
    // } else if (isNaN(formData.employeeRate) || Number(formData.employeeRate) < 0) {
    //   newErrors.employeeRate = t(StringKeys.INVALID_EMPLOYEE_RATE);
    // }
    if (!formData.hireDate?.isValid()) {
      newErrors.hireDate = t(StringKeys.INVALID_DATE);
    }
    if (!formData.birthday?.isValid()) {
      newErrors.birthday = t(StringKeys.INVALID_DATE);
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit({
        userProfile: {
          ...formData,
          birthday: formData.birthday.toDate(),
          hire_date: formData.hireDate.toDate(),
        }
      });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              mb: 1,
              color: 'text.secondary',
              fontSize: '0.925rem'
            }}
          >
            Personal Information
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label={t(StringKeys.FIRST_NAME)}
            value={formData.firstName}
            onChange={(e) => setFormData(prev => ({ ...prev, firstName: e.target.value }))}
            error={!!errors.firstName}
            helperText={errors.firstName}
            fullWidth
            required
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8fafc'
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label={t(StringKeys.LAST_NAME)}
            value={formData.lastName}
            onChange={(e) => setFormData(prev => ({ ...prev, lastName: e.target.value }))}
            error={!!errors.lastName}
            helperText={errors.lastName}
            fullWidth
            required
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8fafc'
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MuiTelInput
            label={t(StringKeys.PHONE)}
            defaultCountry="US"
            value={formData.phoneNumber}
            onChange={(value) => setFormData(prev => ({ ...prev, phoneNumber: value }))}
            error={!!errors.phoneNumber}
            helperText={errors.phoneNumber}
            fullWidth
            required
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8fafc'
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={t(StringKeys.BIRTHDAY)}
              value={formData.birthday}
              onChange={(newValue) => {
                setFormData(prev => ({ 
                  ...prev, 
                  birthday: dayjs(newValue)
                }));
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  required: true,
                  error: !!errors.birthday,
                  helperText: errors.birthday,
                  size: "small",
                  sx: {
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#f8fafc'
                    }
                  }
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12}>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              mt: 1,
              mb: 1,
              color: 'text.secondary',
              fontSize: '0.925rem'
            }}
          >
            Employment Details
          </Typography>
        </Grid>
        {/* <Grid item xs={12} sm={6}>
          <TextField
            label={t(StringKeys.TITLE)}
            value={formData.employeeTitle}
            onChange={(e) => setFormData(prev => ({ ...prev, employeeTitle: e.target.value }))}
            error={!!errors.employeeTitle}
            helperText={errors.employeeTitle}
            fullWidth
            required
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8fafc'
              }
            }}
          />
        </Grid> */}
        {/* <Grid item xs={12} sm={6}>
          <TextField
            label={t(StringKeys.HOURLY_RATE)}
            type="number"
            value={formData.employeeRate}
            onChange={(e) => setFormData(prev => ({ ...prev, employeeRate: e.target.value }))}
            error={!!errors.employeeRate}
            helperText={errors.employeeRate}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
            inputProps={{
              min: 0,
              step: 0.01
            }}
            fullWidth
            required
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8fafc'
              }
            }}
          />
        </Grid> */}
        <Grid item xs={12} sm={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={t(StringKeys.HIRE_DATE)}
              value={formData.hireDate}
              onChange={(newValue) => {
                setFormData(prev => ({ 
                  ...prev, 
                  hireDate: dayjs(newValue)
                }));
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  required: true,
                  error: !!errors.hireDate,
                  helperText: errors.hireDate,
                  size: "small",
                  sx: {
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#f8fafc'
                    }
                  }
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Button 
            type="submit" 
            variant="contained" 
            color="primary"
            sx={{ 
              textTransform: 'none', 
              fontWeight: '600',
              height: '56px',
              fontSize: '16px',
              borderRadius: '30px',
              boxShadow: '0 4px 12px rgba(57, 172, 231, 0.2)',
              mt: 2,
              '&:hover': {
                  boxShadow: '0 6px 16px rgba(57, 172, 231, 0.3)',
              },
              '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
              fullWidth
            >
            {t(StringKeys.NEXT)}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
} 